<script setup lang="ts">
import AsyncImage from '../../../../components/ui/form/AsyncImage.vue';
import { PaymentType } from '../../../../types/models';



const props = defineProps<{
  method: PaymentType;
  selected: boolean;
}>();

const emit = defineEmits<{
  (e: 'select', method: PaymentType): void;
}>();

function selectMethod() {
  emit('select', props.method);
}

</script>

<template>
  <div 
    class="card mb-3 transition-all duration-200 flex items-center cursor-pointer hover:shadow-lg p-4"
    :class="{ 'border-2 border-primary-500 bg-primary-50': selected }"
    @click="selectMethod"
  >
    <div class="text-neutral-700 mr-3">
      <AsyncImage
        class-name="h-6"
        :src="method.icon_image"
        :alt="method.name"
      />
    </div>
    
    <div class="flex-1">
      <h3 class="font-semibold text-neutral-900">{{ method.name }}</h3>
    </div>
    
    <div v-if="selected" class="text-primary-500">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
  </div>
</template>